function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { InputGroup } from "@blueprintjs/core";
//import SingleMedia from "./SingleMedia";
import IntegerField from "../fields/IntegerField";
import TextAreaField from "../fields/TextAreaField";
import MultiSelectListField from "../fields/MultiSelectListField";
import EditableListField from "../fields/EditableListField";
import TextField from "../fields/TextField";
import DecimalField from "../fields/DecimalField";
import BooleanField from "../fields/BooleanField";
import DateField from "../fields/DateField";
import ListField from "../fields/ListField";
import UrlField from "../fields/UrlField";
import DictionaryField from "../fields/DictionaryField";
import MultiSelectDictionaryField from "../fields/MultiSelectDictionaryField";
import AclField from "../fields/AclField";

var FieldControl = function (_Component) {
  _inherits(FieldControl, _Component);

  function FieldControl(props) {
    _classCallCheck(this, FieldControl);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleValueChange = _this.handleValueChange.bind(_this);
    _this.handleDictionaryItemSelect = _this.handleDictionaryItemSelect.bind(_this);
    _this.handleValidityChange = _this.handleValidityChange.bind(_this);
    _this.handleDateTimeChange = _this.handleDateTimeChange.bind(_this);
    _this.handleSuggestChange = _this.handleSuggestChange.bind(_this);
    return _this;
  }

  FieldControl.prototype.handleValueChange = function handleValueChange(value) {
    this.props.onValueChange(value);
  };

  FieldControl.prototype.handleDictionaryItemSelect = function handleDictionaryItemSelect(item, dictionaryConfig) {
    var onDictionaryItemSelect = this.props.onDictionaryItemSelect;

    onDictionaryItemSelect && onDictionaryItemSelect(item, dictionaryConfig);
  };

  FieldControl.prototype.handleValidityChange = function handleValidityChange(valid) {
    var onValidityChange = this.props.onValidityChange;

    onValidityChange && onValidityChange(valid);
  };

  FieldControl.prototype.handleChange = function handleChange(e) {
    var value = e.target.value;

    this.handleValueChange(value);
  };

  FieldControl.prototype.handleDateTimeChange = function handleDateTimeChange(value) {
    this.handleValueChange(value || "");
  };

  FieldControl.prototype.handleSuggestChange = function handleSuggestChange(value) {
    if (this.props.value === value) {
      value = "";
    }
    this.handleValueChange(value);
  };

  FieldControl.prototype.render = function render() {
    var _React$createElement, _React$createElement2;

    var _props = this.props,
        name = _props.name,
        value = _props.value,
        required = _props.required,
        disabled = _props.disabled,
        displayForm = _props.displayForm,
        readOnly = _props.readOnly,
        config = _props.config,
        type = _props.type;

    switch (type) {
      case "textField":
        return React.createElement(TextField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          minLength: config && config.minLength,
          maxLength: config && config.maxLength,
          regex: config && config.regex,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "textAreaField":
        return React.createElement(TextAreaField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          minLength: config && config.minLength,
          maxLength: config && config.maxLength,
          regex: config && config.regex,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "dateField":
        return React.createElement(DateField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "datetimeField":
        return React.createElement(DateField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "booleanField":
        return React.createElement(BooleanField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          minLength: config && config.minLength,
          maxLength: config && config.maxLength,
          regex: config && config.regex,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "decimalField":
        return React.createElement(DecimalField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          minValue: config && config.minValue,
          maxValue: config && config.maxValue,
          decimals: config && config.decimals,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "integerField":
        return React.createElement(IntegerField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          minValue: config && config.minValue,
          maxValue: config && config.maxValue,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "listField":
        // list
        return React.createElement(ListField, {
          name: name,
          items: this.props.items || [],
          value: value,
          onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm,
          isDictionary: this.props.isDictionary
        });

      case "dictionaryField":
        return React.createElement(DictionaryField, {
          name: name,
          value: value,
          onValueChange: this.handleValueChange,
          onDictionaryItemSelect: this.handleDictionaryItemSelect,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm,
          dictionaryConfig: this.props.dictionaryConfig
        });
      case "multiselectDictionaryField":
        return React.createElement(MultiSelectDictionaryField, {
          name: name,
          value: value || [],
          onValueChange: this.handleValueChange,
          onDictionaryItemSelect: this.handleDictionaryItemSelect,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm,
          dictionaryConfig: this.props.dictionaryConfig
        });
      case "multiselectListField":
        return React.createElement(MultiSelectListField, {
          name: name,
          items: this.props.items || [],
          value: value || [] // HS_TODO: Response of digi theme form loader something
          , onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      case "editableListField":
        // editable list
        return React.createElement(EditableListField, {
          name: name,
          items: this.props.items,
          value: value || undefined // HS_TODO: Response of digi theme form loader something
          , onValueChange: this.handleValueChange,
          onValidityChange: this.handleValidityChange,
          required: required,
          disabled: disabled,
          readOnly: readOnly,
          displayForm: displayForm
        });
      /*case "singleMediaField": // single media
        return (
          <SingleMedia
            name={name}
            themeUuid={themeUuid}
            value={value}
            onChange={this.handleValueChange}
            disabled={disabled}
            readOnly={readOnly} displayForm={displayForm}
          />
        );*/
      case "urlField":
        return React.createElement(UrlField, (_React$createElement = {
          name: name,
          disabled: disabled,
          onValidityChange: this.handleValidityChange,
          onValueChange: this.handleValueChange,
          required: required,
          value: value
        }, _React$createElement["disabled"] = disabled, _React$createElement.readOnly = readOnly, _React$createElement.displayForm = displayForm, _React$createElement));

      case "aclField":
        return React.createElement(AclField, (_React$createElement2 = {
          name: name,
          disabled: disabled,
          onValidityChange: this.handleValidityChange,
          onValueChange: this.handleValueChange,
          required: required,
          value: value
        }, _React$createElement2["disabled"] = disabled, _React$createElement2.readOnly = readOnly, _React$createElement2.displayForm = displayForm, _React$createElement2.config = config, _React$createElement2));

      default:
        return displayForm ? React.createElement(
          "span",
          { className: "dt-field-value" },
          value
        ) : React.createElement(InputGroup, { name: name, value: value || "", disabled: true });
    }
  };

  return FieldControl;
}(Component);

FieldControl.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  inline: PropTypes.bool,
  value: PropTypes.any,
  valid: PropTypes.bool,
  onValueChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  regex: PropTypes.string,
  disabled: PropTypes.bool
} : {};

export default FieldControl;